import { I18nLocale } from '#/i18n/types/I18nLocale';
import { searchGetEventsRoutePath } from '#/modules/search/events/routing/searchGetEventsRoutePath';
import { userDashboardCreateEventRoute } from '#/modules/userDashboard/routing/userDashboard.routes';
import { postAListingRoute } from '#/routing/routes';

import type { ParticipateDropdownData } from './types/ParticipateDropdownData';

export const participateDropdownDataEs: ParticipateDropdownData = {
  search: {
    title: 'Participa',
    items: [
      {
        type: 'participate',
        title: 'Cómo Participar',
        href: '/es/dias/participa',
      },
      {
        type: 'post-event',
        title: 'Publicar un Evento',
        href: userDashboardCreateEventRoute.with({}),
        adminUserHref: postAListingRoute.with({}),
      },
      {
        type: 'event',
        title: 'Buscar Eventos',
        href: searchGetEventsRoutePath({ locale: I18nLocale.ES }),
      },
    ],
  },
  resources: {
    title: 'Recursos',
    items: [
      {
        type: 'blog',
        title: 'Blog Idealistas',
        description:
          'Inspiración, consejos y recursos para la participación ciudadana y mucho más.',
        href: '/es/accion?pq=',
      },
      {
        type: 'recipe-for-action',
        title: 'Recetas para la Acción',
        description:
          'Una colección de ideas prácticas para generar cambios positivos alrededor del mundo.',
        href: '/es/recetas-para-accion',
      },
    ],
  },
};
